// extracted by mini-css-extract-plugin
export default {"titleLabel":"ZVaSf6Sx99yVrrqKwG65"};